export enum SettingsUpdatedEvent {
  ForceShow = 'forceShow',
  ForceHide = 'forceHide',
}

export enum SettingsTab {
  ButtonDesign = 'buttonDesign',
}
